var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('div',{staticClass:"user-picture"},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.accessorEmail}}):_c('span',[_vm._v(_vm._s(_vm.getLetter))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }